<template>

        <div class="register-content" >
           <div class="title" :title="title">  {{ title }}</div>
          <table>
              <tr style="height:40px">
                <td><i>*</i>姓名</td>
                <td style="width:140px;">
                     <input type="text" maxlength="4" v-focus v-model="submitParams.name"> 
                
                </td>
                <td style="width:60px"><i>*</i>性别</td>
                <td style="width:70px"><input type="text" maxlength="1" v-model="submitParams.sex" ></td>
                <td style="width:100px"><i>*</i>出生年月</td>
                <td style="width:170px"><input type="text" maxlength="11" v-model="submitParams.birthday" placeholder="yyyy-mm"></td>
                <td rowspan="4"  @click.prevent = "uploadFile()" style="cursor: pointer;" :key="imgFlag">
                  <div v-show="imgFlag" style="width:100%; height:180px"  >
                       <img :src="imgUrl" alt="照片" id="uploadImg"  style="width:100%;height:100%">
                  </div>
                  <span v-show="!imgFlag" >
                        <i>*</i>照片
                  </span>
                </td>
        
                <input id="uploadFile" type="file"  name="myfile" style="display: none;" @change="getFileInfo($event)"/>
              </tr>
              <tr style="height:50px">
                <td><i>*</i>工作单位(学校、院系、专业)</td>
                <td colspan="5"><textarea name="" id="" maxlength="65" style="height:36px" v-model="submitParams.company"></textarea></td>
              </tr>
              <tr style="height:50px">
                <td><i>*</i>身份证号</td>
                <td colspan="5">  <input type="text" maxlength="18" v-model="submitParams.idNo"> </td>
              </tr>
              <tr style="height:40px">
                <td><i>*</i>文化程度</td>
                <td colspan="3"><input type="text" maxlength="14" v-model="submitParams.education"></td>
                <td><i>*</i>政治面貌</td>
                <td ><input type="text" maxlength="8" v-model="submitParams.politics"></td>
              </tr>
              <tr style="height:40px">
                <td><i>*</i>联系地址</td>
                <td colspan="3"><input type="text" maxlength="24" v-model="submitParams.address"></td>
                <td><i>*</i>手机</td>
                <td colspan="2">
                   <input type="text" maxlength="11" v-model="submitParams.phone">
                </td>
              </tr>
              <tr style="height:40px">
                <td><i>*</i>电子邮箱</td>
                <td colspan="3"><input type="text" maxlength="25" v-model="submitParams.email"></td>
                <td>QQ</td>
                <td colspan="2"><input type="text" maxlength="30"  v-model="submitParams.qq"></td>
              </tr>
              <tr style="height:40px">
                <td>外语程度</td>
                <td colspan="3"><input type="text" maxlength="14" v-model="submitParams.language"></td>
                <td>方言</td>
                <td  colspan="2"><input type="text" maxlength="18"  v-model="submitParams.localism"></td>
              </tr>
         
              <tr style="height:125px">
                <td>个人特长</td>
                <td colspan="6"><textarea name="" id="" maxlength="293" style="height:115px" v-model="submitParams.specialty"></textarea></td>
              </tr>
              <tr style="height:90px">
                <td>简述可服务时间</td>
                <td colspan="6"><textarea name="" id="" maxlength="209" style="height:80px" v-model="submitParams.serviceHours"></textarea></td>
              </tr>
              <tr style="height:190px">
                <td>在何时何地有志愿者服务经历</td>
                <td colspan="6"><textarea name="" id="" maxlength="461" style="height:180px" v-model="submitParams.serviceExperience"></textarea></td>
              </tr>
          </table>
          <div class="register" @click = "addVounteer()">提交</div>
          <div class="advice">我们将以邮件/电话方式通知您申请结果，请耐心等待！</div>
        </div>

</template>
<script>

export default {
     name: 'volunteerActivityRegister',
  props: ['id'],

  data(){
     return {
               title:'2021年度上饶美术馆志愿者申请表',
               imgFlag:false,
               imgUrl:'',
               submitParams:
               {
                  imgId:'',
                  name:'',
                  sex:'',
                  birthday:'',
                  company:'',//工作单位
                  idNo:'',//身份证
                  education:'',//文化程度
                  politics:'',///政治面貌
                  address:'',
                  phone:'',
                  email:'',
                  qq:'',
                  language:'',//外语程度
                  localism:'',//方言
                  specialty:'',//个人特长
                  serviceHours:'', //简述可服务时长
                  serviceExperience:'',//在何时何地有志愿者服务经历
               }
            }
  },
  beforeDestroy()
  {
    //  this.imgFlag = false;
    //  this.imgUrl = "";
 
  },
  deactivated: function () {
      //  this.imgFlag = false;
      //  this.imgUrl = "";
   
    },
        mounted()
      {
                 
      },
      activated()
      {           
     
         
      },
  methods:{
    
      jumpItem(link,id)
      {
          console.log(123);
          if(id)
          {
        
              this.$router.push({path:link,query:{id:id}})
          }
          else
          {
              this.$router.push({path: link});
          }
      },//路由跳转函数
      uploadFile()
      {
            console.log(document.querySelector('input[type=file]'));
            let  file = document.querySelector('input[type=file]');
            file.click();

      },
      async getFileInfo(event)
      {
            let img = document.getElementById("uploadImg");
            let file = event.target.files[0];
            let extName = file.name.substring(file.name.lastIndexOf(".")).toLowerCase();
            let AllUpExt = ".jpg|.gif|.bmp|.png|.jpeg|";
            if(AllUpExt.indexOf(extName + "|") == "-1"){
                //this.$utils.message(this, "error", "文件格式不正确!");
                this.$alert('图片格式不正确,请重新选择jpg/gif/png/jpeg格式图片!', '提示', {
                    dangerouslyUseHTMLString: true,
                      confirmButtonClass: 'btnFalses',
                    callback: () => {
                      //this.jumpItem('/volunteer/home/rule');
                    }
                  });
                  return false;
                }else{
            if (file) {

                var reader = new FileReader();
                reader.readAsDataURL(file);
                let  _this = this;
                reader.onloadend = function() {
                     _this.imgUrl = reader.result;
                    _this.imgFlag = true;

                }
            }
             // 上传
            let formData = new FormData();
            formData.append('file',file);
            let headers = {
                            'Content-Type': 'multipart/form-data'
                        };
            await  this.$sr_api.uploadFile(formData, headers).then((res)=>{
              console.log(124);
              this.submitParams.imgId = res.fileId;
              console.log(res.fileId,'this.submitParams.imgId');
            })
            } 

           
      },
      async addVounteer()
      {
        if ( !this.checkFunc())
        {
          return;
        }
        let params = this.submitParams;
        let    headers = {
              "Content-Type": "application/json"
          }
            await  this.$sr_api.addVolunteer(params, headers).then((res)=>{
              console.log(res);
              if(res.code == 200)
              {
                  var html = [];
                  html.push('<div><ul>');
                  html.push("<li>"+'请耐心等待管理人员与您联系'+"</li>");
                  html.push("</ul></div>");
                  this.openSuccess(html);  
                 
              }
              else
              {
                  var html = [];
                  html.push('<div style="color:red"><ul>');
                  html.push("<li>"+res.msg+"</li>");
                  html.push("</ul></div>");
                  this.openError(html);  
              }
         
            })
      },
      required(key, value, html) {
         
            if (value == '' || value == null) {
               switch(key)
               {
                    case 'name' : html.push("<li>"+'姓名不能为空'+"</li>");break;
                    case 'imgId' : html.push("<li>"+'照片不能为空'+"</li>");break;
                    case 'sex' : html.push("<li>"+'性别不能为空'+"</li>");break;
                    case 'birthday' : html.push("<li>"+'出生年月不能为空'+"</li>");break;
                    case 'company' : html.push("<li>"+'工作单位不能为空'+"</li>");break;
                    case 'idNo' : html.push("<li>"+'身份证号码不能为空'+"</li>");break;
                    case 'education' : html.push("<li>"+'文化程度不能为空'+"</li>");break;
                    case 'politics' : html.push("<li>"+'政治面貌不能为空'+"</li>");break;
                    case 'address' : html.push("<li>"+'地址不能为空'+"</li>");break;
                    case 'phone' : html.push("<li>"+'手机号码不能为空'+"</li>");break;
                    case 'email' : html.push("<li>"+'电子邮箱不能为空'+"</li>");break;
                    case 'qq' : html.push("<li>"+'qq不能为空'+"</li>");return true;
                    case 'language' : html.push("<li>"+'外语程度不能为空'+"</li>");return true;
                    case 'localism' : html.push("<li>"+'方言不能为空'+"</li>");return true;
                    case 'specialty' : html.push("<li>"+'个人特长不能为空'+"</li>");return true;
                    case 'serviceHours' : html.push("<li>"+'简述可服务时长不能为空'+"</li>");return true;
                    case 'serviceExperience' : html.push("<li>"+'在何时何地有志愿者服务经历不能为空'+"</li>");return true;
                    // default: html.push("<li>"+'不能为空'+"</li>");
               }
     
                return false;
            }
            return true;
       },
       isDate(date, html) 
       {
            var reg = /^(\d{4})-(\d{2})$/;
            if (date=="") return true;
            if (!reg.test(date) || RegExp.$2 > 12)
            {
                html.push("<li>"+'日期格式为yyyy-mm，请输入正确的日期'+"</li>")
                return false;
            }
            return true;
      },
      isSex(sex, html) 
       {
         console.log(sex,'sex');
            if (sex=="") return true;
            if (sex !== '男' && sex !== '女')
            {
              console.log('jjjjj');
                html.push("<li>"+'请选择性别'+"</li>")
                return false;
            }
            return true;
      },
      isPhone(phone, html)
      {
          let reg = /^[1][3,4,5,7,8][0-9]{9}$/;
          if (phone=="") return true;
          if (!reg.test(phone)) {
             html.push("<li>"+'请输入正确的11位手机号码'+"</li>")
                return false;
            }
             return true;
      },
      isEmail(email, html)
      {
          let reg = /^[a-zA-Z0-9_-]+@([a-zA-Z0-9]+\.)+(com|cn|net|org)$/;
          if (email=="") return true;
          if (!reg.test(email)) {
             html.push("<li>"+'请输入正确的邮箱'+"</li>")
                return false;
            }
             return true;
      },
      isQq(qq, html)
      {
          let reg = /^[1-9][0-9]{4,14}$/;
          if (qq=="") return true;
          if (!reg.test(qq)) {
             html.push("<li>"+'请输入正确的qq号码'+"</li>")
                return false;
            }
             return true;
      },
       isIdNo(idNo, html)
      {
          let reg = /^(^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$)|(^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])((\d{4})|\d{3}[Xx])$)$/;
          if (idNo=="") return true;
          if (!reg.test(idNo)) {
             html.push("<li>"+'身份证号码输入有误，请重新输入'+"</li>")
                return false;
            }
             return true;
      },
      openSuccess(html) 
      {
        this.$alert(html.join(""), '提示', {
          dangerouslyUseHTMLString: true,
            confirmButtonClass: 'btnFalses',
          callback: () => {
             this.jumpItem('/volunteer/home/rule');
          }
        });
      },
      openError(html)
      {
          this.$alert(html.join(""), '提示' , {
            dangerouslyUseHTMLString: true,
             confirmButtonClass: 'btnFalses'
          });
      },
      
  
      checkFunc()
      {
          var html = [];
          html.push('<div style="color:red"><ul>');
          let flag = true;
          console.log(this.submitParams,'this.submitParams');
          for (var k in this.submitParams)
           {
                if (!this.required(k,this.submitParams[k],html)) 
                {           
                    html.push("</ul></div>");      
                    this.openError(html);  
                    flag = false;                
                    break;
                } 
                 if (k == 'sex')
                {
                    if (!this.isSex(this.submitParams[k], html) )
                    {
                        html.push("</ul></div>");
                        this.openError(html);  
                        flag = false;                
                        break;
                    }
                }
                if (k == 'birthday')
                {
                   
                    if (!this.isDate(this.submitParams[k], html) )
                    {
                        html.push("</ul></div>");
                        this.openError(html);  
                        flag = false;                
                        break;
                    }
                }
                if (k == 'phone')
                {
                    
                    if (!this.isPhone(this.submitParams[k], html) )
                    {
                         html.push("</ul></div>");
                        this.openError(html);  
                        flag = false;                
                        break;
                    }
                }
                if (k == 'email')
                {
                  
                    if (!this.isEmail(this.submitParams[k], html) )
                    {
                        html.push("</ul></div>");
                        this.openError(html);  
                        flag = false;                
                        break;
                    }
                }
                 if (k == 'qq')
                {
              
                    if (!this.isQq(this.submitParams[k], html) )
                    {
                        html.push("</ul></div>");
                        this.openError(html);  
                        flag = false;                
                        break;
                    }
                }
                   if (k == 'idNo')
                {
                    
                    if (!this.isIdNo(this.submitParams[k], html) )
                    {
                        html.push("</ul></div>");
                        this.openError(html);  
                        flag = false;                
                        break;
                    }
                }
               
            
           }
           return flag;
        
      }
  },
    directives:{
                focus:{
                    inserted:function(el){
                        el.focus();
                    }
                }
             
                
            }
}
</script>
<style >
i{
  font-style: normal;
  color: #FF0000;
}
    img {
    font-size: 18px;
}
     .register-content {
        width: 860px;
        height: auto;
        margin-top: 40px;
        padding: 30px 30px 20px;
        background-color: #fff;
        border-radius: 10px;
      

    }
    .register-content .title {
        width: 100%;
        text-align: center;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        height: 24px;
        font-size: 24px;
        font-family: SourceHanSansCN-;
        font-weight: 500;
        color: #222222;
        line-height: 24px;
    }
    .register-content table,  .register-content td {
      border: 1px solid black;
    }
       .register-content table {
         margin-top: 20px;
         border-collapse: collapse;
         width: 100%;
         height: auto;
               font-size: 16px;
                     color: #222222;
       }
       .register-content table tr td:first-child {
         width: 110px;
       }
        .register-content table tr td {
        
          text-align: center;
        vertical-align:middle;

        }
        .register-content input {
          width: 100%;

          outline: none;
          text-indent:1em;
        }
         .register-content textarea {
               text-indent:1em;
           width: 100%;
            
                overflow: hidden;
              outline:none;
              resize:none;
              border:none;
              /* background-color: pink; */
             
         }
          .register-content  .register {
            margin: 30px auto 0;
            width: 100px;
            height: 40px;
            line-height: 40px;
            text-align: center;
            background: #B78C0D;
            border: 1px solid #B78C0D;
            border-radius: 4px 4px 4px 4px;
            font-size: 18px;
            font-family: SourceHanSansCN-;
            font-weight: 500;
            color: #FFFFFF;
            cursor: pointer;
        }

  .btnFalses{
          background: #B78C0D  !important;
        border-color: #B78C0D !important;
          color: #FFFFFF !important;
        }
        .advice{
          width: 860px;
          height:14px;
          line-height: 14px;
          font-size: 14px;
          text-align: center;
          margin-top: 15px;
          color: #A7A7A7;
        }
      
</style>